import React from "react";
import { connect } from "react-redux";
import {
  Transition,
  Container,
  Segment,
  Header,
  Button
} from "semantic-ui-react";
import AsignacionActividades from "./shared/colegios/AsignacionActividades";
import ColegioForm from "./shared/colegios/ColegioForm";
import BotonNuevo from "./shared/botones/BotonNuevo";
import { colegiosOps } from "../ducks/colegios";
import { asignacionesOps } from "../ducks/asignaciones";

class DetalleColegio extends React.Component {
  state = { visible: false };

  componentDidMount() {
    const {
      match: { params }
    } = this.props;
    this.setState({ visible: true });
    this.props.obtenerDetalleColegio(params.idColegio);
  }

  componentWillUnmount() {
    this.props.resetActividadesAsignadas();
    this.props.resetDetalleColegio();
  }

  sendDataToServer = (value, contactos) => this.props.updateDataColegio(value);

  handleVolver = () => this.props.history.goBack();

  handleIrAlListado = () =>
    this.props.history.push("/extraescolares/listado/colegios");

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Container>
            <Segment basic>
              <Segment basic>
                <BotonNuevo
                  link="colegio"
                  floated="left"
                  buttonText="Añadir Colegio"
                />

                <Button
                  content="Volver"
                  floated="right"
                  color="pink"
                  icon="cancel"
                  onClick={this.handleVolver}
                />

                <Button
                  content="Ir al listado"
                  floated="right"
                  color="pink"
                  icon="cancel"
                  onClick={this.handleIrAlListado}
                />

                <Header inverted as="h2" textAlign="center">
                  Detalle del Colegio
                </Header>
              </Segment>

              <ColegioForm
                initialValues={this.props.detalleColegio}
                datos={this.props.detalleColegio}
                action={this.sendDataToServer}
              />
              <AsignacionActividades
                idColegio={this.props.detalleColegio.id}
                nombreColegio={this.props.detalleColegio.nombre}
              />
            </Segment>
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  detalleColegio: state.colegios.detalleColegio
});

const actions = {
  /*- colegiosOps -*/
  obtenerDetalleColegio: colegiosOps.obtenerDetalleColegio,
  updateDataColegio: colegiosOps.updateDataColegio,
  resetDetalleColegio: colegiosOps.resetDetalleColegio,
  /*- asignacionesOps -*/
  resetActividadesAsignadas: asignacionesOps.resetActividadesAsignadas
};

export default connect(mapStateToProps, actions)(DetalleColegio);



// WEBPACK FOOTER //
// ./src/pages/DetalleColegio.jsx